
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const BackToTopButton: React.FC = () => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <button
            className={`fixed bottom-8 ltr:right-8 rtl:left-8 z-50 w-10 h-10 rounded-md shadow-lg bg-brand hover:bg-purple-700 items-center justify-center transition-opacity duration-300 ${isVisible ? 'opacity-100 flex' : 'opacity-0 hidden'}`}
            onClick={scrollToTop}
            aria-label={t('goToTop')}
        >
            <svg className="fill-white w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
            </svg>
        </button>
    );
};

export default BackToTopButton;
